// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dv-2";
export var aiChatCartContainerExit = "_dv-4";
export var aiChatContainerLarge = "_dv-0";
export var aiChatContainerSmall = "_dv-1";
export var aiChatIcon = "_dv-6";
export var slideInFromRight = "_dv-3";
export var slideOutToRight = "_dv-5";